// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Icon.module.scss  */
.Icon-module-Root_1g8 {
  display: inline-block;
  pointer-events: none;
  fill: currentColor; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Icon/Icon.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB,EAAE","sourcesContent":["/*  imported from Icon.module.scss  */\n.Icon-module-Root_1g8 {\n  display: inline-block;\n  pointer-events: none;\n  fill: currentColor; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
